import { Engine, Actor, Color, Vector, CollisionType } from 'excalibur';
import { Enemy } from './enemies/enemy';
import { Path } from './path';

class Turn extends Actor {
    private positions : number[][];
    private turnNum : number;
    private direction : number[][];
    private default : number;

    onInitialize() {
        this.makePath(this.turnNum);
    }

    update() {
    }

    constructor(turnNumber, x : number, y : number) {
        super({
            x: x, y: y, height: 10, width: 10, color: Color.fromRGB(0, 0, 0, 0)
        });
        this.turnNum = turnNumber;
        this.direction = [
            [0],//first
            [2],//left
            [6],//left
            [4],//right
            [8],
            [1],//down
            [7],
            [3],//up
            [5],
            [9]//last
        ]
        this.positions = [
            [450, 490],
            [480, 160], 
            [870, 160],
            [890, 705],
            [280, 775],//785->775
            [290, 970],
            [1600, 970],
            [1600, 670],
            [1300, 600],
            [1300, 280]
        ];
        this.default = 150;
    }

    makePath(turnNumber) {
        if(this.direction[0].includes(turnNumber)){
            //call path with correct dimensions
            const path = new Path(
                this.pos.x,
                this.pos.y,
                this.default,
                this.pos.x,
                1,
                0.5,
                -0.1
            );
            this.scene.engine.currentScene.add(path);
        }
        if(this.direction[1].includes(turnNumber)){
            //left
            const path = new Path(
                this.pos.x,
                this.pos.y,
                this.default,
                this.pos.x-this.positions[turnNumber-1][0]+100,
                1,
                0.5,
                0
            );
            this.scene.engine.currentScene.add(path);
        }
        if(this.direction[2].includes(turnNumber)){
            //left
            const path = new Path(
                this.pos.x,
                this.pos.y,
                this.default*0.8,
                this.pos.x-this.positions[turnNumber-1][0]+140,
                1,
                0.5,
                0
            );
            this.scene.engine.currentScene.add(path);
        }
        if(this.direction[3].includes(turnNumber)){
            //right
            const path = new Path(
                this.pos.x,
                this.pos.y,
                this.default*1.1,
                this.positions[turnNumber-1][0]-this.pos.x+85,
                0,
                0.5,
                -0.1
            );
            this.scene.engine.currentScene.add(path);
        }
        if(this.direction[4].includes(turnNumber)){
            //right
            const path = new Path(
                this.pos.x,
                this.pos.y,
                this.default*1,
                this.positions[turnNumber-1][0]-this.pos.x+140,
                0,
                0.5,
                0.1
            );
            this.scene.engine.currentScene.add(path);
        }
        if(this.direction[5].includes(turnNumber)){
            //right
            const path = new Path(
                this.pos.x,
                this.pos.y,
                this.positions[turnNumber-1][1]-this.pos.y+90,
                this.default*1.2,
                0.5,
                0,
                0
            );
            this.scene.engine.currentScene.add(path);
        }
        if(this.direction[6].includes(turnNumber)){
            //right
            const path = new Path(
                this.pos.x+50,
                this.pos.y,
                this.positions[turnNumber-1][1]-this.pos.y+65,
                this.default*1.15,
                0.5,
                0,
                0
            );
            this.scene.engine.currentScene.add(path);
        }
        if(this.direction[7].includes(turnNumber)){
            //right
            const path = new Path(
                this.pos.x,
                this.pos.y,
                this.pos.y-this.positions[turnNumber-1][1]+65,
                this.default*1.15,
                0.5,
                1,
                0
            );
            this.scene.engine.currentScene.add(path);
        }
        if(this.direction[8].includes(turnNumber)){
            //right
            const path = new Path(
                this.pos.x-25,
                this.pos.y,
                this.pos.y-this.positions[turnNumber-1][1]+80,
                this.default*1.5,
                0.5,
                1,
                0
            );
            this.scene.engine.currentScene.add(path);
        }
        if(this.direction[9].includes(turnNumber)){
            //right
            const path = new Path(
                this.pos.x-25,
                this.pos.y,
                this.positions[turnNumber-1][1]-this.pos.y+80,
                this.default*1.3,
                0.5,
                0,
                0
            );
            this.scene.engine.currentScene.add(path);
            const path1 = new Path(
                this.pos.x-120,
                this.pos.y-30,
                this.default*0.9,
                2040-this.pos.x,
                0,
                0.5,
                0
            );
            this.scene.engine.currentScene.add(path1);
        }
        // if(this.direction[2].includes(turnNumber)){
        //     //left
        //     var a = this.calDist('x', this.positions[turnNumber-1]);
        //     var b = this.pos.x - 10;
        //     const path = new Path(
        //         (a - b) / 2 + b,
        //         this.pos.y,
        //         this.default,
        //         a - b
        //     );
        //     this.scene.engine.currentScene.add(path);
        // }
        // if(this.direction[3].includes(turnNumber)){
        //     //left
        //     var a = this.calDist('y', this.positions[turnNumber-1]);
        //     var b = this.pos.y;
        //     const path = new Path(
        //         this.pos.x - 10,
        //         (a - b) / 2 + b,
        //         a - b,
        //         this.default
        //     );
        //     this.scene.engine.currentScene.add(path);
        // }
        // if(this.direction[4].includes(turnNumber)){
        //     //left
        //     var a = this.pos.y;
        //     var b = this.calDist('y', this.positions[turnNumber-1]);
        //     const path = new Path(
        //         this.pos.x - 10,
        //         (a - b) / 2 + b,
        //         a - b,
        //         this.default
        //     );
        //     this.scene.engine.currentScene.add(path);
        //}
    }

    // calDist(parity, value) {
    //     if(parity == 'x'){
    //         return (value[0]) * 192;
    //     } else if(parity = 'y'){
    //         return (value[1]) * 810/11 - 30;
    //     } else {
    //         return 10;
    //     }
    // }
    
}

export { Turn } 